import { Component } from '@angular/core';

@Component({
  selector: 'em-maintenance-management-system-details',
  templateUrl: './maintenance-management-system-details.component.html',
  standalone: false,
})
export class MaintenanceManagementSystemDetailsComponent {}
